module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container a3d trial"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isShowForm) ? _c('div', [_c('h6', {
    staticClass: "form-title center"
  }, [_vm._v("FREE TRIAL REGISTRATION")]), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          First Name\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.firstName.current),
      expression: "form.firstName.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.firstName.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.firstName, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.form.firstName.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your First Name")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          Last Name\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lastName.current),
      expression: "form.lastName.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.lastName.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.lastName, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.form.lastName.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your Last Name")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email.current),
      expression: "form.email.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.email.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.email, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.form.email.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your email")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center buttons-block"
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _c('button', {
    staticClass: "btn a3d",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Sign Up")])]), _vm._v(" "), (_vm.error) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Something went wrong")]) : _vm._e()]), _vm._v(" "), _vm._m(2)]) : (_vm.submitted) ? _c('div', {
    staticClass: "center"
  }, [_c('h6', {
    staticClass: "form-title"
  }, [_vm._v("An invitation to AM Build Optimizer has been sent to your email.")])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center buttons-block"
  }, [_c('button', {
    staticClass: "btn a3d",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("Start Free Trial")]), _vm._v(" "), _c('a', {
    staticClass: "btn a3d inv",
    attrs: {
      "href": _vm.loginHost
    }
  }, [_vm._v("Log in")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "responsive-img center-align",
    attrs: {
      "src": "/static/img/siemens_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center"
  }, [_c('h5', [_vm._v("AM Build Optimizer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('ol', [_c('li', [_vm._v("\n          The trial subscription will be active for 30 days.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          You will be asked to enter your email and create a password, you should use the same\n          email and password you use for other Siemens sites you may have access to.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          You can submit optimizations from within NX-AM from the modeling perspective. You can\n          also submit optimizations directly through the web-based user interface at\n          "), _c('a', {
    attrs: {
      "href": "https://portal.atlas3d.xyz"
    }
  }, [_vm._v("https://portal.atlas3d.xyz")]), _vm._v(" or\n          "), _c('a', {
    attrs: {
      "href": "https://portal.atlas3dxyz.com"
    }
  }, [_vm._v("https://portal.atlas3dxyz.com")]), _vm._v(". Finally, you\n          can also submit optimizations from within any NX installation you may have on your\n          computer, provided it has been updated to version 1957 or later. Simply install the NX\n          plugin by running the application called "), _c('strong', [_vm._v("“Atlas3DtoNX.exe”")]), _vm._v(" available at\n          "), _c('strong', [_vm._v("C:\\Program Files\\Siemens\\NX[Version Number]\\MACH\\auxiliary\\mfgam")]), _vm._v(". For\n          either of these options, you must first complete the onboarding process for the AM Build\n          Optimizer trial.\n        ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b602f5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b602f5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trial.vue
// module id = 490
// module chunks = 1